import React, { useState } from 'react';
import { arrayMove } from '@dnd-kit/sortable';
import PropTypes from 'prop-types';
import { Anchor } from '@mantine/core';
import MediaDropzone from './MediaDropzone';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';
import AppCheckbox from '../../common/AppCheckbox';

const VendorMediaSortableDropzone = ({
  title,
  media,
  onChange,
  disabled,
  canChangeImages,
  fkEcomVendor,
  fkEcomStore
}) => {
  const [
    selectedEcomVendorProductMediaKeys,
    setSelectedEcomVendorProductMediaKeys
  ] = useState([]);

  const selectedMedia = media.filter((m) =>
    selectedEcomVendorProductMediaKeys.includes(m.key)
  );

  return (
    <>
      {!selectedMedia.length ? (
        <AppFlexbox
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 16
          }}
        >
          <AppFlexbox
            onClick={() => setSelectedEcomVendorProductMediaKeys([])}
            style={{ alignItems: 'center', gap: 8, cursor: 'pointer' }}
          >
            {title || (
              <AppText style={{ fontSize: 16, fontWeight: 700 }}>Media</AppText>
            )}
          </AppFlexbox>
        </AppFlexbox>
      ) : (
        <AppFlexbox
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 16
          }}
        >
          <AppFlexbox
            onClick={() => setSelectedEcomVendorProductMediaKeys([])}
            style={{ alignItems: 'center', gap: 8, cursor: 'pointer' }}
          >
            <AppCheckbox checked onChange={() => {}} size="xs" />
            <AppText style={{ fontSize: 16, fontWeight: 500 }}>
              {selectedMedia.length} selected
            </AppText>
          </AppFlexbox>

          <Anchor
            onClick={() => {
              if (!disabled) {
                onChange(
                  media.filter(
                    (m) => !selectedEcomVendorProductMediaKeys.includes(m.key)
                  )
                );
                setSelectedEcomVendorProductMediaKeys([]);
              }
            }}
            style={{ fontSize: 14, color: '#c40000', fontWeight: 500 }}
          >
            Remove
          </Anchor>
        </AppFlexbox>
      )}

      <MediaDropzone
        disabled={disabled}
        enableMediaSelect
        files={media}
        fkEcomStore={fkEcomStore}
        fkEcomVendor={fkEcomVendor}
        onChangeOrder={({ active, over }) => {
          const oldIndex = media.findIndex((f) => f.sort === active.id);
          const newIndex = media.findIndex((f) => f.sort === over.id);
          onChange(
            arrayMove(media, oldIndex, newIndex).map((item, index) => ({
              ...item,
              sort: index + 1
            }))
          );
        }}
        onSelectFile={
          canChangeImages
            ? (file) => {
                if (
                  !selectedEcomVendorProductMediaKeys.find(
                    (k) => k === file.key
                  )
                ) {
                  setSelectedEcomVendorProductMediaKeys([
                    ...selectedEcomVendorProductMediaKeys,
                    file.key
                  ]);
                }
                else {
                  setSelectedEcomVendorProductMediaKeys([
                    ...selectedEcomVendorProductMediaKeys.filter(
                      (k) => k !== file.key
                    )
                  ]);
                }
              }
            : null
        }
        onUpload={(uploadedMedia) => {
          const newMedia = [
            ...media.filter((m) => uploadedMedia.some((u) => u.key === m.key)),
            ...uploadedMedia
              .filter((m) => !media.some((me) => me.key === m.key))
              .map((m, index) => ({
                ...m,
                fkEcomVendorMedia: m.fkEcomVendorMedia ?? null,
                src: m.src,
                preview: m.preview
              }))
          ].map((m, i) => ({
            ...m,
            sort: i + 1
          }));
          onChange(newMedia);
        }}
        selectedMediaKeys={selectedEcomVendorProductMediaKeys}
        showSortGrid
        uploadHidden={!canChangeImages}
        uploadOnDrop
      />
    </>
  );
};

VendorMediaSortableDropzone.propTypes = {
  media: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  canChangeImages: PropTypes.bool,
  disabled: PropTypes.bool,
  fkEcomStore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fkEcomVendor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.node
};

export default VendorMediaSortableDropzone;
